import classnames from 'classnames'

export interface IChainSelector {
  selected: string
  chains?: string[]
  onSelect: any
}

const ChainSelector = ({
  selected,
  chains = ['bnb', 'ethereum', 'polygon', 'multiversx'],
  onSelect,
}: IChainSelector) => {
  return (
    <div className="flex flex-col gap-4 md:flex-row">
      {chains.map((chain, key) => (
        <button
          className={classnames(
            'flex items-center rounded-lg border px-4 py-1 text-sm text-white',
            {
              '!text-main-blue': chain === selected,
            },
          )}
          onClick={() => onSelect(chain)}
          key={key}>
          <span className={`icon-${chain.toLowerCase()} mr-2 text-xl`} />
          <span className="capitalize">{chain}</span>
        </button>
      ))}
    </div>
  )
}

export default ChainSelector
